<mat-form-field class="full-width" appearance="outline">
  <mat-label>{{ getLabel() }}</mat-label>

  <input required readonly matInput [value]="getAdminDisplayName()" />
  <button
    color="primary"
    matIconSuffix
    mat-icon-button
    (click)="selectAdmin()"
    matTooltip="{{ selectLabel | translate: locale.language }}"
    [attr.aria-label]="selectLabel | translate: locale.language">
    <mat-icon>person_search</mat-icon>
  </button>
  <mat-hint>{{ hint }}</mat-hint>
</mat-form-field>
